import update from 'immutability-helper';
import { NotificationData } from 'src/models';
import { ActionType, defaultAction } from 'src/redux/types';
import { ACTION_TYPES } from './types';

export type FetchNotificationState = {
  data: NotificationData;
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type SubmitNotificationState = {
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type UpdateReceiveMoneyToReceiverNotificationState = {
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type UpdateLowBalanceNotificationState = {
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type NotificationState = {
  fetch: FetchNotificationState;
  submit: SubmitNotificationState;
  updateReceiveMoneyToReceiver: UpdateReceiveMoneyToReceiverNotificationState;
  updateLowBalance: UpdateLowBalanceNotificationState;
};

const initialState: NotificationState = {
  fetch: {
    data: {
      username: '',
      email: '',
      emailLowBalance: '',
      emailAsyncReport: '',
      emailReceiveMoneyReceiver: '',
      successNotificationEnabled: '',
      enabledReceiveMoneyNotification: '',
      enabledReceiveMoneyToReceiverNotification: '',
      logoUrl: '',
      senderIdentity: '',
      brandName: '',
      companyName: '',
      lowBalanceThreshold: 0,
    },
    loading: false,
    isSuccess: false,
    error: '',
  },
  submit: {
    loading: false,
    isSuccess: false,
    error: '',
  },
  updateReceiveMoneyToReceiver: {
    loading: false,
    isSuccess: false,
    error: '',
  },
  updateLowBalance: {
    loading: false,
    isSuccess: false,
    error: '',
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.NOTIFICATION_FETCH:
      return update(state, {
        fetch: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.NOTIFICATION_FETCH_SUCCESS:
      return update(state, {
        fetch: {
          $merge: {
            data: payload.data,
            loading: false,
            isSuccess: true,
          },
        },
      });

    case ACTION_TYPES.NOTIFICATION_FETCH_FAILED:
      return update(state, {
        fetch: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });

    case ACTION_TYPES.NOTIFICATION_SUBMIT:
      return update(state, {
        submit: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.NOTIFICATION_SUBMIT_SUCCESS:
      return update(state, {
        submit: {
          $merge: {
            loading: false,
            isSuccess: !payload.reason && payload.status_code === 200,
          },
        },
      });

    case ACTION_TYPES.NOTIFICATION_SUBMIT_FAILED:
      return update(state, {
        submit: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });
    case ACTION_TYPES.NOTIFICATION_UPDATE_RECEIVE_MONEY_TO_RECEIVER:
      return update(state, {
        updateReceiveMoneyToReceiver: {
          loading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.NOTIFICATION_UPDATE_RECEIVE_MONEY_TO_RECEIVER_SUCCESS:
      return update(state, {
        updateReceiveMoneyToReceiver: {
          $merge: {
            loading: false,
            isSuccess: !payload.reason && payload.status_code === 200,
          },
        },
      });
    case ACTION_TYPES.NOTIFICATION_UPDATE_RECEIVE_MONEY_TO_RECEIVER_FAILED:
      return update(state, {
        updateReceiveMoneyToReceiver: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });
    case ACTION_TYPES.NOTIFICATION_UPDATE_LOW_BALANCE:
      return update(state, {
        updateLowBalance: {
          loading: {
            $set: true,
          },
        },
      });
    case ACTION_TYPES.NOTIFICATION_UPDATE_LOW_BALANCE_SUCCESS:
      return update(state, {
        fetch: {
          $merge: {
            data: payload.data,
          },
        },
        updateLowBalance: {
          $merge: {
            loading: false,
            isSuccess: !payload.reason && payload.status_code === 200,
          },
        },
      });
    case ACTION_TYPES.NOTIFICATION_UPDATE_LOW_BALANCE_FAILED:
      return update(state, {
        updateLowBalance: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });
    default:
      return state;
  }
};
